'use strict';

var StrategyAllocationAuthAvailDirective = function StrategyAllocationAuthAvailDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'StrategyAllocationAuthAvailActionsController',
    template: require('../templates/strategy-allocation-auth-avail-actions.html'),
    scope: {
      strategy: '='
    },
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
StrategyAllocationAuthAvailDirective.$inject = [];
module.exports = StrategyAllocationAuthAvailDirective;